export const isInSqspOrg = (currentUser: any): boolean => {
  return 'squarespaceMemberId' in currentUser;
};

export const isPendingInvitationStatus = (status?: string | null): boolean => {
  return status === 'SENT' || status === 'EXPIRED';
};
